<template>
  <div>
    <!--    <nav-bar class="home-nav">-->
    <!--      <div slot="center">课程信息</div>-->
    <!--    </nav-bar>-->
    <van-nav-bar
      :title="this.$cookies.get('info').sName+' 欢迎您'"
      right-text="退出账号"
      right-arrow
      @click-right="exit"
      left-text="联系我们"
      @click-left="contact"
    />

    <!--    <div v-if="this.select">-->
    <!--      <div style="text-align: center;margin: 10px;font-family: 楷体"><h3>课程介绍</h3></div>-->
    <!--      <div style="overflow-y: scroll;margin: 15px;padding: 5px;border:1px solid cadetblue;border-radius: 10px"-->
    <!--           v-html='coursehtml'>-->
    <!--      </div>-->

    <!--      <div style="text-align: center;margin: 10px;font-family: 楷体"><h3>课程二维码</h3></div>-->
    <!--      <van-row>-->
    <!--        <van-col span="24"><img style="width: 100%;padding: 20px" :src="this.img" alt=""></van-col>-->
    <!--      </van-row>-->
    <!--    </div>-->
    <van-cell-group v-if="this.courseSelect" title="当前课程">
      <van-swipe-cell>
        <van-card
          :desc="'上课时间:'+time+',负责老师:'+CourseTeacher"
          :title="course"
          class="goods-card"
          thumb="http://cdn.sport.hhstu.xyz/%E8%AF%BE%E7%A8%8B%20%281%29.png"
        >

          <template #tags>
            <van-tag plain type="primary">您的课程成绩:{{ score }}</van-tag>
          </template>
          <template #footer>
            <van-button @click="drop" type="danger" size="mini">退课</van-button>
            <van-button @click="courseShow = true" type="primary" size="mini">查看</van-button>
          </template>
        </van-card>

        <!--        <van-cell :border="false" :label="'上课时间:'+time" :title="course" value="<<滑动<<"/>-->
        <!--        <template slot="right">-->
        <!--          <van-button square @click="drop" type="danger" text="退课"/>-->
        <!--          <van-button square @click="courseShow = true" type="primary" text="查看"/>-->
        <!--        </template>-->

      </van-swipe-cell>
    </van-cell-group>

    <van-cell-group v-if="this.clubSelect" title="当前俱乐部">
      <van-swipe-cell>
        <van-card
          :desc="'负责老师:'+ClubTeacher"
          :title="club"
          class="goods-card"
          thumb="http://cdn.sport.hhstu.xyz/%E4%BC%9A%E5%91%98%E4%BF%B1%E4%B9%90%E9%83%A8.png"
        >
          <template #tags>
            <van-tag plain type="primary">您的俱乐部运动等级:{{ ranks }}</van-tag>
            <van-tag color="#ffe1e1" text-color="#ad0000">您的俱乐部总训练时间:{{ getEtime }}</van-tag>
          </template>
          <template #footer>
            <van-button @click="VenueRecord" size="mini" type="info">预约记录</van-button>
            <van-button @click="trainRecord" size="mini" type="info">训练记录</van-button>
            <van-button @click="QuitClub" type="danger" size="mini">退俱乐部</van-button>
            <van-button @click="clubShow = true" type="primary" size="mini">详细</van-button>
          </template>
        </van-card>

        <!--        <van-cell :border="false" :label="'当前俱乐部等级:'+ranks" :title="club" value="<<滑动<<"/>-->
        <!--        <template slot="right">-->
        <!--          <van-button square type="info" text="预约记录"/>-->
        <!--          <van-button square @click="clubShow = true" type="primary" text="查看"/>-->
        <!--        </template>-->
      </van-swipe-cell>
    </van-cell-group>


    <van-action-sheet position="right" v-model="courseShow" :title="this.course+' 课程介绍和二维码' ">
      <van-empty v-if="!this.courseSelect" description="你还未选课"/>
      <div>
        <!--        <h3 style="text-align: center">{{course+',上课时间:'+time}}</h3>-->
        <div class="content">
          {{ this.courseDescription }}
        </div>
        <img style="width: 100%;padding: 20px" :src="this.img" alt="">
      </div>
    </van-action-sheet>

    <van-action-sheet position="top" v-model="clubShow" :title="this.club+' 俱乐部介绍' ">
      <van-empty v-if="!this.clubSelect" description="你还未选择俱乐部"/>
      <div>
        <div class="content">{{ this.clubDescription }}</div>
      </div>
    </van-action-sheet>

    <van-action-sheet position="top" v-model="venueRecordShow" :title="this.club+' 俱乐部场馆预约记录' ">

      <van-cell-group>
        <van-cell v-for="(item,index) in venueRecords" :title="item.time" :label="item.vname+'场馆'" :key="index">
          <div v-if="new Date().getTime()>=parseInt(item.clHours)">已结束</div>
          <div v-if="new Date().getTime()>parseInt(item.opHours)&&new Date().getTime()<parseInt(item.clHours)">
            进行中
          </div>
          <div v-if="new Date().getTime()<parseInt(item.opHours)">
            <van-button @click="cancelBooking(item.id)" type="danger" size="mini">取消预约</van-button>
          </div>
        </van-cell>

      </van-cell-group>

    </van-action-sheet>

    <van-action-sheet position="top" v-model="trainRecordShow" :title="this.club+' 俱乐部场馆训练记录' ">

      <van-cell-group>
        <van-cell v-for="(item,index) in trainRecords"
                  :title="item.time" :value="'时长'+item.etime+'分钟'"
                  :label="item.vname+'场馆'" :key="index"/>
      </van-cell-group>

    </van-action-sheet>

    <van-empty v-if="(!this.courseSelect)&&(!this.clubSelect)" description="暂未选择课程或者俱乐部"/>

    <div style="padding-top: 50px"></div>

    <van-dialog v-model="contactShow" title="联系我们">
      <div style="text-align: center;margin: 10px 0 20px 0;line-height: 20px">
        <h5>如果你有好的改进建议</h5>
        <h5>如果你想加入我们</h5>
        <h5>如果你有其他合作</h5>
        <h5>欢迎联系我们</h5>

        <p>联系邮箱:<a style="color: #7dbfff" href="mailto:joarn.work@gmail.com">joarn.work@gmail.com</a></p></div>
    </van-dialog>

  </div>
</template>

<script>
import Vue from 'vue'
import {
  NavBar,
  Dialog,
  Toast,
  CellGroup,
  SwipeCell,
  Cell,
  Empty,
  Row,
  Col,
  ActionSheet,
  Button,
  Card,
  Tag,
} from 'vant';
import {
  GetCourseInfo,
  GetClubInfo,
  StuDropCourse,
  StuDropClub,
  GetVenueRecord,
  GetTrainRecord
} from "../../network/student";
import {CancelVunueBooking} from "@/network/venue";

Vue.use(NavBar);
Vue.use(Dialog);
Vue.use(Toast);
Vue.use(CellGroup);
Vue.use(Cell);
Vue.use(SwipeCell);
Vue.use(Empty);
Vue.use(Row);
Vue.use(Col);
Vue.use(ActionSheet);
Vue.use(Button);
Vue.use(Card);
Vue.use(Tag);
export default {
  name: "StuProfile",
  components: {},
  data() {
    return {
      // course ActionSheet
      course: "",
      courseDescription: "",
      time: ' ',
      courseSelect: false,
      img: "",
      courseShow: false,
      CourseTeacher: "",
      score: 0,

      // club ActionSheet
      club: "",
      clubDescription: "",
      clubSelect: false,
      clubShow: false,
      ranks: 1,
      ClubTeacher: "",
      etime: 0,

      // VenueRecord ActionSheet
      venueRecords: [],
      venueRecordShow: false,

      // TrainRecord ActionSheet
      trainRecords: [],
      trainRecordShow: false,

      contactShow: false,
    }
  },
  // mounted() {
  //   GetCourseInfo().then(res => {
  //     this.course = res.course;
  //     this.coursehtml = res.html;
  //     this.time = '上课时间'+res.time;
  //   });
  // },
  activated() {
    GetCourseInfo().then(res => {
      this.course = res.course;
      this.courseDescription = res.des;
      this.time = res.time;
      this.courseSelect = res.select;
      this.img = res.img;
      this.CourseTeacher = res.CourseTeacher;
      this.score = res.score;
    });
    GetClubInfo().then(res => {
      this.club = res.club;
      this.clubDescription = res.des;
      this.clubSelect = res.select;
      this.ranks = res.ranks;
      this.ClubTeacher = res.ClubTeacher;
      this.etime = res.etime;
    })
  },
  computed: {
    getEtime() {
      return Math.floor(this.etime / 60) + '小时' + this.etime % 60 + '分钟'
    }
  },
  methods: {
    exit() {
      if (document.domain.indexOf("fzxy") != -1) {
        Toast.fail('翻转校园内不允许退出');
        return;
      }
      Dialog.confirm({
        title: '提示',
        message: '确定退出账号吗',
      }).then(() => {
        this.$cookies.remove("islogin");
        this.$cookies.remove("user");
        this.$cookies.remove("info");
        this.$router.replace("/login")
        location.reload();
      }).catch(() => {
      });
    },
    drop() {
      Dialog.confirm({
        title: '提示',
        message: '确定要退课吗'
      }).then(() => {
        StuDropCourse().then(res => {
            if (res.droped) {
              Toast.success(res.message);
              location.reload();
            } else {
              Toast.fail(res.message);
            }
          }
        ).catch(res => {
          Toast.fail("退课失败");
        })
        // on confirm
      }).catch(() => {
        // on cancel
      });
    },
    QuitClub() {
      Dialog.confirm({
        title: '警告',
        message: '确定要退出俱乐部吗，退出后，训练记录将消失'
      }).then(() => {
        StuDropClub().then(res => {
            if (res.droped) {
              Toast.success(res.message);
              location.reload();
            } else {
              Toast.fail(res.message);
            }
          }
        ).catch(res => {
          Toast.fail("退出俱乐部失败");
        })
        // on confirm
      }).catch(() => {
        // on cancel
      });
    },
    parseDate(date) {
      if (date >= 10)
        return date;
      return '0' + date;
    },
    VenueRecord() {
      GetVenueRecord().then(res => {
        this.venueRecords = res;
        for (let i = 0; i < this.venueRecords.length; i++) {
          let d1 = new Date(parseInt(this.venueRecords[i].opHours));
          let d2 = new Date(parseInt(this.venueRecords[i].clHours));
          let time = d1.getFullYear() + '-' + (d1.getMonth() + 1) + '-' + d1.getDate() + ' ' + this.parseDate(d1.getHours()) + ':' + this.parseDate(d1.getMinutes()) + '-' + this.parseDate(d2.getHours()) + ':' + this.parseDate(d2.getMinutes());
          this.venueRecords[i]['time'] = time;
        }
        this.venueRecordShow = true;
      })
    },
    trainRecord() {
      GetTrainRecord(this.$cookies.get('info').id).then(res => {
        this.trainRecords = res;
        for (let i = 0; i < this.trainRecords.length; i++) {
          let d1 = new Date(parseInt(this.trainRecords[i].stTime));
          let d2 = new Date(parseInt(this.trainRecords[i].edTime));
          let time = d1.getFullYear() + '-' + (d1.getMonth() + 1) + '-' + d1.getDate() + ' ' + this.parseDate(d1.getHours()) + ':' + this.parseDate(d1.getMinutes()) + '-' + this.parseDate(d2.getHours()) + ':' + this.parseDate(d2.getMinutes());
          this.trainRecords[i]['time'] = time;
        }
        this.trainRecordShow = true;
      })
    },
    cancelBooking(id) {
      Dialog.confirm({
        title: '提示',
        message: '确定要取消预约吗'
      }).then(() => {
        CancelVunueBooking(id).then(res => {
            if (res.status) {
              Toast.success("取消成功");
              this.venueRecords = this.venueRecords.filter(item => item.id != id);
            } else {
              Toast.fail(res.message);
            }
          }
        ).catch(res => {
          Toast.fail("取消失败");
        })
        // on confirm
      }).catch(() => {
        // on cancel
      });
    },
    contact() {
      this.contactShow = true;
    }
  },
}
</script>

<style scoped>
.home-nav {
  background: #c9d6ff; /* fallback for old browsers */
  background: -webkit-linear-gradient(to right, rgb(201, 214, 255), rgb(226, 226, 226)); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to right, rgb(201, 214, 255), rgb(226, 226, 226)); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  color: #fff;
}

.content {
  padding: 16px 16px 30px;
}
</style>
